import AddIcon from '@mui/icons-material/Add'
import { Button, Grid } from '@mui/material'
import { ChargeException } from 'api/models/ChargeException.type'
import { ChargeRate, TaxiRate } from 'api/vehicle/taxisRatesAPI.types'
import styles from 'components/Supplier/Manage/manageSupplierStyle'
import React, { Dispatch } from 'react'
import RoutePricingGridTitles from './RoutePricingGridTiles'
import RoutePricingStandardRateRow from './RoutePricingStandardRateRow'

interface Props {
  rateDetail: TaxiRate
  waitingTime: string
  chargeRates: Array<ChargeRate>
  isEdit: boolean
  additionalStop: boolean
  waitAndReturn: boolean
  setChargeRates: Dispatch<React.SetStateAction<Array<ChargeRate>>>
  chargeExceptions?: Array<ChargeException>
}

export const RoutePricing = (props: Props) => {
  const {
    rateDetail,
    waitingTime,
    chargeRates,
    setChargeRates,
    isEdit,
    additionalStop,
    waitAndReturn,
    chargeExceptions,
  } = props
  //   const { chargeExceptions } = useSupplierState()
  console.log('RoutePricing Props', props)

  const handleAdd = () => {
    let exceptions = (chargeExceptions ?? []).map((e: ChargeException) => {
      if (chargeRates.length > 0) {
        const found: any = chargeRates[0].chargeExceptions.find(
          (ce) => ce?.chargeExceptionId === e.id,
        )
        return {
          chargeExceptionId: e.id,
          chargeTypeName: found?.chargeTypeName,
          percentage: found?.percentage,
          premium: found?.premium,
        }
      }
      return {
        chargeExceptionId: e.id,
        chargeTypeName: undefined,
        percentage: undefined,
        premium: undefined,
      }
    })

    const rate = {
      id: chargeRates.length + 1,
      taxiId: undefined,
      chargeExceptions: [...exceptions],
    }
    setChargeRates((prev: any) => [...prev, rate])
  }

  console.log('Route Pricing isEdit', isEdit)

  return (
    <>
      <RoutePricingGridTitles
        waitingTime={waitingTime}
        chargeRates={chargeRates}
        setChargeRates={setChargeRates}
        isEdit={isEdit}
        additionalStop={additionalStop}
        waitAndReturn={waitAndReturn}
      />
      <RoutePricingStandardRateRow
        taxiRate={rateDetail}
        waitingTime={waitingTime}
        chargeRates={chargeRates}
        additionalStop={additionalStop}
        waitAndReturn={waitAndReturn}
        setChargeRates={setChargeRates}
        isEdit={isEdit}
      />
      {/* <RoutePricingChargeOverrides
        waitingTime={waitingTime}
        chargeRates={chargeRates}
        additionalStop={additionalStop}
        waitAndReturn={waitAndReturn}
        setChargeRates={setChargeRates}
        isEdit={isEdit}
      /> */}
      <Grid container item spacing={0} direction="row" sx={{ minWidth: '70%' }}>
        {isEdit && (
          <Grid item xs={4}>
            <Button
              variant="contained"
              endIcon={<AddIcon />}
              onClick={handleAdd}
              sx={styles.fieldSpacing}
            >
              Add mileage range
            </Button>
          </Grid>
        )}
      </Grid>
    </>
  )
}
export default RoutePricing
